var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#heart_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#heart_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.137 12.074a.29.29 0 0 1-.274 0L7 11.817zm4.821-7.257c0-1.278-1.082-2.334-2.442-2.334-1.015 0-1.88.59-2.25 1.422a.292.292 0 0 1-.533 0c-.37-.832-1.234-1.422-2.249-1.422-1.36 0-2.442 1.056-2.442 2.334 0 1.983 1.24 3.66 2.532 4.866a14 14 0 0 0 2.349 1.754l.077.045q.035-.02.077-.045a13.954 13.954 0 0 0 2.349-1.755c1.293-1.204 2.532-2.882 2.532-4.865m.584 0c0 2.228-1.386 4.05-2.718 5.292A14.5 14.5 0 0 1 7.2 12.04l-.047.025-.012.007-.004.002v.001L7 11.817l-.137.257h-.001l-.004-.003-.012-.007-.047-.025-.173-.099a14.538 14.538 0 0 1-2.45-1.83C2.844 8.866 1.458 7.044 1.458 4.816c0-1.622 1.366-2.917 3.026-2.917 1.047 0 1.972.514 2.516 1.298A3.05 3.05 0 0 1 9.516 1.9c1.66 0 3.026 1.295 3.026 2.917"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "heart_svg__a",
    width: 14,
    height: 14.5,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_489_4128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_489_4128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "heart_svg__b",
    width: 11.083,
    height: 10.708,
    x: 1.458,
    y: 1.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_489_4128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_489_4128",
    result: "shape"
  })))));
};
export default SvgHeart;